<body>
    <div class="headerContratos">
        <div class="align-left search">
            <input type="text" [(ngModel)]="searchString" (keyup)="aplicarFiltro()" placeholder="Filter">
            <input #dateInput2 type="date" class="dateInput" id="dateInput2" [(ngModel)]="dateFilter">
            <button class="inputDate" (click)="applyFilter()">Filtrar</button>
            <button class="inputDate" (click)="clearFilter()">Limpar filtro</button>
        </div>
        <h3 class="subtitulo" style="font-family: 'Times New Roman', Times, serif;">Fretes Extra Concluídos</h3>
        <div class="align-right">
            <div class="icone-setting">
                <!-- <div class="icone-setting">
                    <button class="btn-frete icone-setting" mat-button (click)="solicitarFrete()"><i-feather
                            name="file-plus"></i-feather>Solicitar Frete Extra</button>
                </div> -->
                <div class="icone-setting">
                    <button class="btn-frete icone-setting" mat-button (click)="exportToExcel(items)"><i-feather
                            name="printer"></i-feather>Print</button>
                </div>
            </div>
        </div>
    </div>
    <ul>
        <table id="excel-table">
            <thead>
                <tr class="header-row">
                    <td><label>ID</label></td>
                    <td><label>Data</label></td>
                    <td><label>Data Coleta</label></td>
                    <td><label>Origem</label></td>
                    <td><label>Endereço Coleta</label></td>
                    <td><label>Destino</label></td>
                    <td><label>Endereço Destino</label></td>
                    <td><label>Data entrega</label></td>
                    <td><label>Requisitante</label></td>
                    <td><label>Transportador</label></td>
                    <td><label>Veículo Disponível</label></td>
                    <td><label>Veículo Requisitado</label></td>
                    <td><label>Placa</label></td>
                    <td><label>Status</label></td>
                    <td><label>Ações</label></td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items" [class]="getStatusClass(item.status)">
                    <td>{{ item.ID }}</td>
                    <td>{{ item.date | date:'dd-MM-yy'}}</td>
                    <td>{{ item.datePickup | date:'dd-MM-yy' + " " + item.timePickup }}</td>
                    <td>{{ (item.locationPickup == "other" ? item.otherLocationPickup : item.locationPickup) +
                        (item.areaPickup ?
                        " - " + item.areaPickup : "")}}</td>
                    <td>{{ item.addressPickup + (item.cityPickup ? " - " + item.cityPickup : "") + (item.statePickup ? "
                        - " +
                        item.statePickup : "")}}</td>
                    <td>{{ (item.locationDelivery == "other" ? item.otherLocationDelivery : item.locationDelivery) +
                        (item.areaDelivery ? " - " + item.areaDelivery : "")}}</td>
                    <td>{{ item.addressDelivery + (item.cityDelivery ? " - " + item.cityDelivery : "") +
                        (item.stateDelivery ? " -
                        " + item.stateDelivery : "") }}</td>
                    <td>{{ item.dateDelivery | date:'dd-MM-yy' + " " + item.timeDelivery }}</td>
                    <td>{{ item.reqName + " - " + item.reqId}}</td>
                    <td>{{ item.carrier}}</td>
                    <td>{{ item.vehicleType}}</td>
                    <td>{{ item.reqVehicle}}</td>
                    <td>{{ item.plate}}</td>
                    <td>{{ item.status}}</td>
                    <td class="action-buttons">
                        <button [disabled]="!isAdminEnabled" mat-icon-button color="primary" aria-label="Editar"
                            (click)="editDialog(item)">
                            <span class="material-icons">edit</span>
                        </button>

                        <button mat-icon-button color="warn" aria-label="Print" (click)="addImageToExcel(item)">
                            <span class="material-icons">print</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </ul>
</body>
<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <!-- <div> -->

    <h3 class="modal-title">Solicitação de Frete Extra</h3>
    <h3 class="modal-title" style="font-size: 15px;">Contact: <abbr style="color: #3b82f6; font-size: 15px;"> SSBVAD
        </abbr>
        Phone: 55 11 4344-8947 | Mobile: +55 11
        97488-2943</h3>
    <!-- </div> -->
    <div class="modal-body scroll-container">
        <form class="inputs">
            <table class="table2000">
                <tr *ngIf="usuarioLogado">
                    <td [class]="getStatusClass(item.status)" class="camposLabels selectStatus">
                        <H2>{{ item.status }}</H2>
                    </td>
                    <td class="camposLabels selectStatus"
                        *ngIf="(usuarioLogado.role ==  '0' || usuarioLogado.role ==  '2') && item.status == 'Reject'">
                        <button type="button" label="requested" (click)="item.status = 'Requested'">REQUISITADO</button>
                    </td>
                    <td class="camposLabels selectStatus"
                        *ngIf="item.status == 'Requested'  && (usuarioLogado.role == '3' || usuarioLogado.role ==  '0' || usuarioLogado.role ==  '2')">
                        <button type="button" label="Accept" (click)="item.status = 'Planned'">ACEITAR</button>
                    </td>
                    <td class="camposLabels selectStatus"
                        *ngIf="item.status == 'Requested'  && (usuarioLogado.role == '3' || usuarioLogado.role ==  '0' || usuarioLogado.role ==  '2')">
                        <button type="button" label="reject" (click)="item.status = 'Reject'">REJEITAR</button>
                    </td>
                    <td class="camposLabels selectStatus"
                        *ngIf="(usuarioLogado.role ==  '0' || usuarioLogado.role ==  '2') && item.status != 'Completed' && item.status != 'Canceled'">
                        <button type="button" label="cancel" (click)="item.status = 'Canceled'">CANCELAR</button>
                    </td>
                    <td class="camposLabels selectStatus"
                        *ngIf="(item.status == 'Planned' && (usuarioLogado.role == '3' || usuarioLogado.role ==  '0' || usuarioLogado.role ==  '2'))">
                        <button type="button" label="executing" (click)="item.status = 'Executing'">EXECUTANDO</button>
                    </td>
                    <td class="camposLabels selectStatus"
                        *ngIf="item.status == 'Executing' && (usuarioLogado.role == '3' || usuarioLogado.role ==  '0' || usuarioLogado.role ==  '2')">
                        <button type="button" label="completed" (click)="item.status = 'Completed'">FINALIZADA</button>
                    </td>

                </tr>
                <tr>
                    <td>
                        <label class="modal-label">Motivo da solicitação</label>
                    </td>
                    <td class="align-left input-maior">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="motive"
                            [(ngModel)]="item.motive" class="modal-input0" [required]="true">
                    </td>

                    <td>
                        <label class="modal-label">Numero da NF</label>
                    </td>
                    <td>
                        <input type="text" name="nf" [(ngModel)]="item.nf" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Valor total da NF</label>
                    </td>
                    <td>
                        <input type="text" name="nfTotal" [(ngModel)]="item.nfTotal" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Valor do Frete</label>
                    </td>
                    <td>
                        <input type="text" name="totalCost" [(ngModel)]="item.totalCost" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td>
                        <label class="modal-label">Peso (Kg)</label>
                    </td>
                    <td>
                        <input type="text" name="weight" [(ngModel)]="item.weight" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Quantidade</label>
                    </td>
                    <td>
                        <input type="text" name="quantity" [(ngModel)]="item.quantity" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Descrição do Material</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="description" [(ngModel)]="item.description" class="modal-input0">
                    </td>
                </tr>
                <tr>
                    <td class="selectStatus">
                        <label class="modal-label">Transport.</label>
                    </td>
                    <td class="selectStatus">
                        <select [disabled]="!isAdminEnabled" class="selectVehicle" name="carrier"
                            [(ngModel)]="item.carrier" appendTo="body">
                            <option value="-" disabled selected>-</option>
                            <option *ngFor="let type of this.carriers" [value]="type.name">{{ type.name }}</option>
                            <option value="other">Other</option>
                        </select>
                        <!-- <input [disabled]="!isCarrierEnabled" type="text" name="carrier" [(ngModel)]="item.carrier"
              class="modal-input1"> -->
                    </td>
                    <td>
                        <label class="modal-label">Veículo Solicitado*</label>
                    </td>
                    <td>
                        <select [disabled]="!isAdminEnabled && !isUserEnabled" id="reqVehicle" name="reqVehicle"
                            [(ngModel)]="item.reqVehicle" class="modal-select" (blur)="onFieldTouched()">
                            <option *ngFor="let vehicle of typesVehicles" [value]="vehicle">{{ vehicle }}</option>
                        </select>
                        <div
                            *ngIf="campoTocado && (item.reqVehicle == null || item.reqVehicle == undefined || item.reqVehicle == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td>
                        <label class="modal-label">Veículo Disponível</label>
                    </td>
                    <td>
                        <select [disabled]="!isCarrierEnabled && !isAdminEnabled" id="vehicleType" name="vehicleType"
                            [(ngModel)]="item.vehicleType" class="modal-select">
                            <option *ngFor="let vehicle of typesVehicles" [value]="vehicle">{{ vehicle }}</option>
                        </select>
                    </td>
                    <td>
                        <label class="modal-label">Placa do Veículo</label>
                    </td>
                    <td>
                        <input [disabled]="!isAdminEnabled && !isCarrierEnabled" type="text" name="plate"
                            [(ngModel)]="item.plate" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td class="selectStatus">
                        <label class="modal-label">Nome do requisitante*</label>
                    </td>
                    <td class="align-left selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="reqName"
                            (blur)="onFieldTouched()" [(ngModel)]="item.reqName" class="modal-input0">
                        <div
                            *ngIf="campoTocado && (item.reqName == null || item.reqName == undefined || item.reqName == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Usuário*</label>
                    </td>
                    <td class="selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="reqId"
                            [(ngModel)]="item.reqId" class="modal-input1" (blur)="onFieldTouched()">
                        <div *ngIf="campoTocado && (item.reqId == null || item.reqId == undefined || item.reqId == '')">
                            <small class="text-danger">Required {{ item.reqId }}</small>
                        </div>
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">E-mail*</label>
                    </td>
                    <td class="align-left selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="reqEmail"
                            [(ngModel)]="item.reqEmail" class="modal-input0" (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.reqEmail == null || item.reqEmail == undefined || item.reqEmail == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Contato*</label>
                    </td>
                    <td class="input-maior selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="reqPhone"
                            [(ngModel)]="item.reqPhone" class="modal-input1" (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.reqPhone == null || item.reqPhone == undefined || item.reqPhone == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="selectStatus">
                        <label class="modal-label">E-mail do Gestor</label>
                    </td>
                    <td class="selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="supEmail"
                            [(ngModel)]="item.supEmail" class="modal-input1">
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Centro de Custo*</label>
                    </td>
                    <td class="selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="costCenter"
                            [(ngModel)]="item.costCenter" class="modal-input1" (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.costCenter == null || item.costCenter == undefined || item.costCenter == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Numero do Projeto</label>
                    </td>
                    <td class="selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="projectNumber"
                            [(ngModel)]="item.projectNumber" class="modal-input1">
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Numero da OS</label>
                    </td>
                    <td class="selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="orderNumber"
                            [(ngModel)]="item.orderNumber" class="modal-input1">
                    </td>
                </tr>
                <br>
                <h3 class="modal-title">Informações de coleta</h3>
                <br>
                <tr>
                    <td class="selectStatus">
                        <label class="modal-label">Local de coleta*</label>
                    </td>
                    <td class="selectStatus">
                        <select [disabled]="!isAdminEnabled && !isUserEnabled" class="selectVehicle"
                            name="locationPickup" [(ngModel)]="item.locationPickup" appendTo="body"
                            (blur)="onFieldTouched()" (ngModelChange)="onFieldChanged('locationPickup', $event)">
                            <option *ngFor="let type of this.placesOrigin" [value]="type">{{ type }}</option>
                            <option value="other">Other</option>
                        </select>
                        <div
                            *ngIf="campoTocado && (item.locationPickup == null || item.locationPickup == undefined || item.locationPickup == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td class="selectStatus"
                        *ngIf="item.locationPickup == 'SCANIA SBC' || item.locationPickup == 'Scania SLA' || item.locationPickup == 'SCANIA LATIN AMERICA - SLA' || item.locationPickup == 'SCANIA LATIN AMERICA - LCB'">
                        <label class="modal-label">Área</label>
                    </td>
                    <td class="selectStatus"
                        *ngIf="item.locationPickup == 'SCANIA SBC' || item.locationPickup == 'Scania SLA' || item.locationPickup == 'SCANIA LATIN AMERICA - SLA' || item.locationPickup == 'SCANIA LATIN AMERICA - LCB'">
                        <input type="text" name="areaDelivery" placeholder="Ex.: P27-05" [(ngModel)]="item.areaDelivery"
                            class="modal-input1">
                    </td>
                    <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
                        <label class="modal-label">Nome da Empresa</label>
                    </td>
                    <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
                        <input type="text" name="otherLocationPickup" [(ngModel)]="item.otherLocationPickup"
                            class="modal-input1">
                    </td>

                    <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
                        <label class="modal-label">Endereço</label>
                    </td>
                    <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
                        <input type="text" name="addressPickup" [(ngModel)]="item.addressPickup" class="modal-input1"
                            (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.addressPickup == null || item.addressPickup == undefined || item.addressPickup == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
                        <label class="modal-label">Cidade</label>
                    </td>
                    <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
                        <input type="text" name="cityPickup" [(ngModel)]="item.cityPickup" class="modal-input1">
                    </td>
                    <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
                        <label class="modal-label">Estado</label>
                    </td>
                    <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
                        <input type="text" name="statePickup" [(ngModel)]="item.statePickup" class="modal-input1">
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Data da Coleta*</label>
                    </td>
                    <td class="selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="date" name="datePickup"
                            [(ngModel)]="item.datePickup" class="modal-input1" (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.datePickup == null || item.datePickup == undefined || item.datePickup == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Horário de Coleta*</label>
                    </td>
                    <td class="input-maior selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="time" name="timePickup"
                            [(ngModel)]="item.timePickup" class="modal-input1" (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.timePickup == null || item.timePickup == undefined || item.timePickup == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                </tr>
                <br>
                <h3 class="modal-title">Informações de entrega</h3>
                <br>
                <tr>
                    <td class="selectStatus">
                        <label class="modal-label">Local de entrega*</label>
                    </td>
                    <td class="selectStatus">
                        <!-- <input type="text" name="locationDelivery" [(ngModel)]="item.locationDelivery" class="modal-input1"> -->
                        <select [disabled]="!isAdminEnabled && !isUserEnabled" class="selectVehicle"
                            name="locationDelivery" [(ngModel)]="item.locationDelivery" appendTo="body"
                            (blur)="onFieldTouched()" (ngModelChange)="onFieldChanged('locationDelivery', $event)">
                            <!-- <option [value]="item.locationDelivery"></option> -->
                            <option *ngFor="let typeDelivey of this.placesOrigin" [value]="typeDelivey">{{ typeDelivey}}
                            </option>
                            <option value="other">Other</option>
                        </select>
                        <div
                            *ngIf="campoTocado && (item.locationDelivery == null || item.locationDelivery == undefined || item.locationDelivery == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td class="selectStatus"
                        *ngIf="item.locationDelivery == 'SCANIA SBC' || item.locationDelivery == 'Scania SLA' || item.locationDelivery == 'SCANIA LATIN AMERICA - SLA' || item.locationDelivery == 'SCANIA LATIN AMERICA - LCB'">
                        <label class="modal-label">Área</label>
                    </td>
                    <td class="selectStatus"
                        *ngIf="item.locationDelivery == 'SCANIA SBC' || item.locationDelivery == 'Scania SLA' || item.locationDelivery == 'SCANIA LATIN AMERICA - SLA' || item.locationDelivery == 'SCANIA LATIN AMERICA - LCB'">
                        <input type="text" name="areaDelivery" placeholder="Ex.: P27-05" [(ngModel)]="item.areaDelivery"
                            class="modal-input1">
                    </td>
                    <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
                        <label class="modal-label">Nome da Empresa</label>
                    </td>
                    <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
                        <input type="text" name="otherLocationDelivery" [(ngModel)]="item.otherLocationDelivery"
                            class="modal-input1">
                    </td>
                    <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
                        <label class="modal-label">Endereço</label>
                    </td>
                    <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
                        <input type="text" name="addressDelivery" [(ngModel)]="item.addressDelivery"
                            class="modal-input1" (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.addressDelivery == null || item.addressDelivery == undefined || item.addressDelivery == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
                        <label class="modal-label">Cidade</label>
                    </td>
                    <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
                        <input type="text" name="cityDelivery" [(ngModel)]="item.cityDelivery" class="modal-input1">
                    </td>
                    <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
                        <label class="modal-label">Estado</label>
                    </td>
                    <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
                        <input type="text" name="stateDelivery" [(ngModel)]="item.stateDelivery" class="modal-input1">
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Data de entrega*</label>
                    </td>
                    <td class="selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="date" name="dateDelivery"
                            [(ngModel)]="item.dateDelivery" class="modal-input1" (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.dateDelivery == null || item.dateDelivery == undefined || item.dateDelivery == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Horário de Entrega*</label>
                    </td>
                    <td class="input-maior selectStatus">
                        <input [disabled]="!isAdminEnabled && !isUserEnabled" type="time" name="timeDelivery"
                            [(ngModel)]="item.timeDelivery" class="modal-input1" (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.timeDelivery == null || item.timeDelivery == undefined || item.timeDelivery == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label class="modal-label">Observações</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="notes" [(ngModel)]="item.notes" class="modal-input0">
                    </td>
                    <td>
                        <label class="modal-label">Item Crítico?</label>
                    </td>
                    <td>
                        <input type="checkbox" id="critical">
                    </td>
                    <td>
                        <label class="modal-label">Produto Perigoso?</label>
                    </td>
                    <td>
                        <input type="checkbox" id="dangerousProduct">
                    </td>
                </tr>
            </table>
            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar(item)">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>